import React from "react";
import MvModal from './MvModal'
// @ts-ignore
import { LocalizationContext } from 'react-localize';
// Styles
import "./HopperConfirmationModal.sass";
import "./modal.css";

interface Props {
    header?: string;
    description: string;
    message: string;
    abortLabel?: string;
    confirmLabel: string;
    openModal: boolean;
    closeiconnato: boolean;
    toggleModal: () => void;
    abort: () => void;
    confirm: () => void;
};

class MvHopperConfirmationModal extends React.Component<Props, {}> {

    render() {
        const { localize } = this.context;
        let modalBody;
        if (this.props.description) {
            modalBody = (
                <div className='modal-body hopper-modal-body'>
                    {localize(this.props.description)}
                </div>
            );
        }
        return (
            <MvModal
                id="hopper-modal"
                openModal={this.props.openModal}
                closeiconnato={this.props.closeiconnato}
                toggleModal={this.props.toggleModal}>
                <div className="hopper-confirmation-modal">
                    <div className='modal-header'>
                        {this.props.header ? <p className="hopper-headline">{localize(this.props.header)}</p>: "" }
                        <p className="hopper-headline">{localize(this.props.message)}</p>
                    </div>
                    {modalBody}
                    <div className='modal-footer'>
                        <div className=''>
                            <button
                                type='button'
                                className='mv-button primary'
                                ref='confirm'
                                onClick={this.props.confirm}
                            >
                                {localize(this.props.confirmLabel)}
                            </button>
                            {this.props.abortLabel &&
                                <button
                                    type='button'
                                    className='mv-button primary'
                                    onClick={this.props.abort}
                                >
                                    {localize(this.props.abortLabel)}
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </MvModal>
        );
    }
};

MvHopperConfirmationModal.contextType = LocalizationContext;
export {
    MvHopperConfirmationModal,
};
